import * as d3 from "d3";
import latinAmerica from "../utils/latin-america.json";
import volumeData from "../utils/volume_by_country.json";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import { useEffect, useState } from "react";
import { StepBubbles } from "./stepBubbles";
import useWindowDimensions from "../utils/useWindoeDimensions";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";


import TEXT from '../../../utils/text/prensa.json'

const data = volumeData
  .filter((elm) => elm.country !== "LATAM")
  .map((elm) => {
    const array = elm.date.split("/");
    if (array.length > 2) elm.date = `${array[0]}/${array[2]}`;
    return elm;
  });

const maxValue = Math.round(Math.max(...data.map((elm) => elm.volume)) + 1);
const trimestres = [...new Set(data.map((elm) => elm.date))].sort((a, b) => {
  const arrayA = a.split("/");
  const arrayB = b.split("/");
  return new Date(arrayA[1], arrayA[0]) < new Date(arrayB[1], arrayB[0])
    ? -1
    : 1;
});
const minRange = 0;
const maxRange = trimestres.length - 1;
const minYearTrim = trimestres[0].split("/")[1];
const maxYearTrim = trimestres[trimestres.length - 1].split("/")[1];
export default function StepMap({ currentStepIndex, progress, stepNumber }) {
  const [rangeValue, setRangeValue] = useState(minRange);
  const { width: windowWidth } = useWindowDimensions();
  const finalStepMap = stepNumber + 3;

  const { language } = useCurrentLanguage();
  
  useEffect(() => {
    function handleRange() {
      if (currentStepIndex === stepNumber + 1) setRangeValue(minRange);
      else if (currentStepIndex === finalStepMap) setRangeValue(maxRange);
      if (currentStepIndex === stepNumber + 2) {
        const n = maxRange - minRange;
        setRangeValue(minRange + Math.round(progress.progress * n));
      }
    }
    handleRange();
  }, [progress.progress, currentStepIndex, stepNumber, finalStepMap]);

  useEffect(() => {
    const updateMapColor = () => {
      // Select all map paths and update color based on currentDate
      d3.selectAll("#g-path > path").attr("fill", (d) => {
        const filtered =
          (data.filter(
            (elm) =>
              elm.date === trimestres[rangeValue] &&
              elm.id === d.properties.adm0_a3
          )[0]?.volume *
            0.85) /
          maxValue;
        return filtered ? `rgba(48, 94, 169, ${0.15 + filtered})` : " #D8D8D8";
      });
    };
    updateMapColor();
  }, [rangeValue]);

  useEffect(() => {
    
    drawMap()
      function drawMap() {
        const width = 300;
        const height = 400;
        // The svg
        d3.selectAll("svg#map > *").remove();
        let svg = d3.select("svg#map");
    
        // Map and projection
        var projection = d3
          .geoNaturalEarth1()
          .scale(width / 1.5)
          .translate([
            width * (windowWidth < 768 || windowWidth > 1440 ? 1.2 : 1.5),
            height / 2.5,
          ]);
        // Draw the map
        svg
          .append("g")
          .attr("id", "g-path")
          .selectAll("path")
          .data(latinAmerica.features)
          .enter()
          .append("path")
          .attr("fill", (d) => {
            const filtered =
              (data.filter(
                (elm) =>
                  elm.date === trimestres[0] && elm.id === d.properties.adm0_a3
              )[0]?.volume *
                0.85) /
              maxValue;
            return filtered ? `rgba(48, 94, 169, ${0.15 + filtered})` : " #D8D8D8";
          })
          .attr("d", d3.geoPath().projection(projection))
          .style("stroke", "#fff")
          .style("stroke-width", 0.2);
      }
    }, [windowWidth]);


  console.log("currentStepIndex", currentStepIndex);
  return (
    progress && (
      <div className={` h-screenn`}>
        <div
          style={{
            top:
              progress.data === 13
                ? `${5 - progress.progress * 100}%`
                : progress.data >= 13
                ? "-105%"
                : "5%",
            maxWidth: "1022px",
            minWidth: currentStepIndex === 4 ? "933px" : "",
            width: `${
              progress.data === stepNumber - 1
                ? progress.progress * 100 - 20
                : progress.data < stepNumber - 1 || !progress.data
                ? 0
                : windowWidth < 768
                ? 95
                : 80
            }%`,
          }}
          className={`shadow-main fixed top-16  h-[90%] bg-white mx-auto rounded-20 right-0 left-0`}
        >
          <div
            className={`text-black p-4 lg:p-8 2xl:p-16 ${
              currentStepIndex < stepNumber - 1 ? "p-0" : ""
            } flex items-center h-full `}
          >
            <div
              style={{
                opacity:
                  currentStepIndex < stepNumber ||
                  currentStepIndex > finalStepMap + 1
                    ? 0
                    : currentStepIndex === stepNumber ||
                      currentStepIndex === stepNumber + 1 ||
                      currentStepIndex === stepNumber + 2
                    ? 1
                    : progress.progress !== 1 && progress.progress !== 0
                    ? 1 - progress.progress
                    : 0,
              }}
              className={`w-full flex flex-col md:flex-row items-center h-full transition-all  ${
                currentStepIndex >= finalStepMap + 1 ? "hidden" : "flex"
              }`}
            >
              <div className="w-full md:w-2/3 flex flex-col md:h-full md:justify-end">
                <p
                  className={`text-dark-grey  font-semibold text-left  ${
                    currentStepIndex > stepNumber
                      ? "text-[0px] md:text-base"
                      : "text-base"
                  } text-lg md:text-xl desktop:text-2xl`}
                >
                  {TEXT['mixed_feelings']['step2']['map']['description'][language]}
                </p>
                <p className="mb-8 text-base desktop:text-xl desktop:mt-2 text-left">
                  {language === "es" ? "Trimestre" : "Trimester"}: {trimestres[rangeValue].split("/")[0]/3}/{trimestres[rangeValue].split("/")[1]}
                </p>
                <div
                  className={`${
                    currentStepIndex < stepNumber + 1
                      ? "opacity-0"
                      : "opacity-1"
                  } transition-all  hidden md:block`}
                >
                  <RangeSlider
                    onInput={(e) => (e ? setRangeValue(e[1]) : null)}
                    value={[minRange, rangeValue]}
                    min={minRange}
                    max={maxRange}
                    step={1}
                    thumbsDisabled={[true, false]}
                  />

                  <ul className="flex mt-4 justify-between text-black">
                    {[minYearTrim, maxYearTrim].map((elm) => (
                      <li key={elm}>{elm}</li>
                    ))}
                  </ul>
                  <p className="mt-8 mb-4 text-left">
                  {TEXT['mixed_feelings']['step2']['map']['footer'][language]}
                  </p>
                  <div
                    className="h-6 rounded-20 w-full"
                    style={{
                      background:
                        "linear-gradient(90deg, #FFFFFF 0%,#305EA9 100%)",
                    }}
                  />
                  <div className="flex justify-between mt-4">
                    <p>0%</p>
                    <p>{maxValue}%</p>
                  </div>
                </div>
              </div>{" "}
              <svg
                className={`${
                  currentStepIndex > stepNumber ? "block" : "hidden"
                } md:block`}
                id="map"
                width="100%"
                height="100%"
                viewBox="0 0 300 400"
              />
              <div
                className={`${
                  currentStepIndex < stepNumber + 1 ? "opacity-0" : "opacity-1"
                } transition-all mt-auto block md:hidden`}
              >
                <RangeSlider
                  onInput={(e) => (e ? setRangeValue(e[1]) : null)}
                  value={[minRange, rangeValue]}
                  min={minRange}
                  max={maxRange}
                  step={1}
                  thumbsDisabled={[true, false]}
                />

                <ul className="flex mt-4 justify-between text-black">
                  {[minYearTrim, maxYearTrim].map((elm) => (
                    <li key={elm}>{elm}</li>
                  ))}
                </ul>
                <p className="mt-4 mb-2 text-sm	">
                  Intensidad de la cobertura mediática en migraciones
                </p>
                <div className="flex flex-nowrap items-center gap-2">
                  <p className="text-sm">0%</p>
                  <div
                    className="h-4 rounded-20 grow"
                    style={{
                      background:
                        "linear-gradient(90deg, #FFFFFF 0%,#305EA9 100%)",
                    }}
                  />
                  <p className="text-sm">{maxValue}%</p>
                </div>

                
              </div>
            </div>{" "}
            <StepBubbles
              stepBubbles={finalStepMap + 1}
              currentStepIndex={currentStepIndex}
              progress={progress}
            />
          </div>
        </div>
      </div>
    )
  );
}
